import { default as React, useState } from 'react'
import { People } from '@mui/icons-material'
import ListAllUsers from './ListAllUsers'

import ListViewCommandBar from '../commandBar/ListViewCommandBar'
import Page from '../layout/Page'

export default function ListAllUsersPage (props = {}) {
  const [isLoading, setIsLoading] = useState(true)

  const startLoading = () => {
    setIsLoading(true)
  }

  const stopLoading = () => {
    setIsLoading(false)
  }

  const breadcrumb = <span><People/>MFI User Management</span>

  const [showFilters, setShowFilters] = useState(false)
  const toggleFilters = () => {
    setShowFilters(!showFilters)
  }

  const [showAddRecord, setShowAddRecord] = useState(false)
  const addRecord = () => {
    setShowAddRecord(true)
  }
  const hideAddRecord = () => {
    setShowAddRecord(false)
  }

  return (
    <Page { ...props} breadcrumb={breadcrumb} isLoading={isLoading} commandBar={<ListViewCommandBar toggleFilters={toggleFilters} addRecord={addRecord} listView={{ getAddItemUrl: () => {return "/users/edit/new"}}} /> }>
      <ListAllUsers showFilters={showFilters} showAddRecord={showAddRecord} startLoading={startLoading} stopLoading={stopLoading} hideAddRecord={hideAddRecord}/>
    </Page>
  )
}